<template>
  <div id="cookie-consent" role="banner" class="" aria-label="Cookie Notice">
    <div class="wrapper" style="color: #fff">
      <span class="cookie-icon"><i data-lucide="cookie" class="inline-block w-9 h-9"></i></span>
      <p class="text-base">
        Unsere Webseite verwendet technisch notwendige Cookies. Durch das
        Aufrufen der Seite akzeptieren Sie deren Nutzung. Darüber hinaus können
        weitere Cookies Ihr Nutzererlebnis optimieren und uns Analysen zur
        Verbesserung unserer Seite ermöglichen. Mit einem Klick auf
        “Akzeptieren” stimmen Sie diesen zu. Weitere Informationen finden Sie in
        unserer <a href="/datenschutzerklaerung">Datenschutzerklärung.</a>
      </p>

      <div class="flex justify-center items-center space-x-8">
        <div class="text-sm">
          <a href="/cookie-settings" class="text-white">Cookie Settings</a>
        </div>
        <div>
          <plain-button @click="acceptCookies">Akzeptieren</plain-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";

const cookieConsentUrl = "/cookie-consent";

onMounted(() => {
  window.lucide?.createIcons();
});

const acceptCookies = () => {
  console.log("acceptCookies");
  const currentUrl = encodeURIComponent(window.location.href);
  const redirectUrl = `${cookieConsentUrl}?redirect=${currentUrl}`;
  window.location.href = redirectUrl;
};
</script>

<style scoped>
#cookie-consent {
  background-color: rgba(33, 33, 33, 0.9);
  position: fixed;
  min-width: 100%;
  min-height: 40%;
  height: auto;
  z-index: 100000;
  text-align: center;
  left: 0;
  bottom: 0;
  font-size: 16px;
  line-height: 20px;
}

#cookie-consent .wrapper {
  padding: 50px 10% 75px;
}

.cookie-icon {
  display: inline-block;
  font-size: 36px;
  padding-bottom: 10px;
}
</style>
